module.exports = __webpack_public_path__ + "img/1440.06aaa64a.jpg";